import { render, staticRenderFns } from "./RareCancerPage.vue?vue&type=template&id=0e7f0d52&scoped=true"
var script = {}
import style0 from "./RareCancerPage.vue?vue&type=style&index=0&id=0e7f0d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7f0d52",
  null
  
)

export default component.exports